module.exports = __webpack_public_path__ + "img/Vector-1.4a3fb998.png";